import React from 'react';

import useCurrencyFormatter from '~/components/CurrencyFormatterContext';

export const AmountCurrencyFormattedCell: React.FC<{ amount: number }> = ({ amount }) => {
  const { currencyFormatter } = useCurrencyFormatter();

  return <>{currencyFormatter.format(amount)}</>;
};
